import { MEDIA_QUERIES } from 'javascripts/constants';
import Slider from '../../../javascripts/globals/slider';

export default class RsmbwfaktdbSlider extends Slider {
  constructor($teaserSlider, mq, config) {
    super($teaserSlider, mq, config);
    this.$slider = $teaserSlider;
    // this.hasFiveSlides = this.$slider?.classList.contains(
    //   'teaser-slider--five'
    // );
    // this.hasOneSlide = this.$slider?.classList.contains('teaser-slider--one');
    this.itemsToScroll = this.getItemsToScroll();
    this.itemsVisible = this.getItemsToScroll(); // kannst du gleichsetzen mit itemsToScroll

    if (this.itemsToScroll < this.numberOfSlides) {
      this.initControls();
      super.initEvents();
    }
  }

  handleResize() {
    this.itemsToScroll = this.getItemsToScroll();
    this.itemsVisible = this.itemsToScroll;
    super.handleResize();
  }

  initControls() {
    this.itemsToScroll = this.getItemsToScroll();
    this.itemsVisible = this.itemsToScroll;
    super.initControls();
  }

  updateArrows() {
    this.itemsToScroll = this.getItemsToScroll();
    this.itemsVisible = this.itemsToScroll;
    super.updateArrows();
  }

  updateDots() {
    this.itemsToScroll = this.getItemsToScroll();
    this.itemsVisible = this.itemsToScroll;
    super.updateDots();
  }

  renderDots() {
    this.itemsToScroll = this.getItemsToScroll();
    this.itemsVisible = this.itemsToScroll;
    super.renderDots();
  }

  nextSlide() {
    this.itemsToScroll = this.getItemsToScroll();
    this.itemsVisible = this.itemsToScroll;
    super.nextSlide();
  }

  prevSlide() {
    this.itemsToScroll = this.getItemsToScroll();
    this.itemsVisible = this.itemsToScroll;
    super.prevSlide();
  }

  // getItemsVisible() {
  //   if (this.hasOneSlide) {
  //     return 1;
  //   }

  //   this.hasFiveSlides = this.$slider?.classList.contains(
  //     'teaser-slider--five'
  //   );

  //   const mqXl = window.matchMedia(MEDIA_QUERIES.xl);
  //   const mqM = window.matchMedia(MEDIA_QUERIES.m);

  //   // mobile
  //   let itemsVisible = 1;

  //   if (this.hasFiveSlides) {
  //     itemsVisible = 2;
  //   }

  //   // tablet
  //   if (mqM.matches) {
  //     itemsVisible = 2;

  //     if (this.hasFiveSlides) {
  //       itemsVisible = 3;
  //     }
  //   }

  //   // tablet landscape or small desktop
  //   if (mqXl.matches) {
  //     itemsVisible = 3;

  //     if (this.hasFiveSlides) {
  //       itemsVisible = 5;
  //     }
  //   }

  //   return itemsVisible;
  // }

  getItemsToScroll() {
    // if (this.hasOneSlide) {
    //   return 1;
    // }

    // this.hasFiveSlides = this.$slider?.classList.contains(
    //   'teaser-slider--five'
    // );

    // ### Matze hier mit config.itemsToScroll Objekt arbeiten

    const mqXl = window.matchMedia(MEDIA_QUERIES.xl);
    const mqXXl = window.matchMedia(MEDIA_QUERIES.xxl);
    const mqM = window.matchMedia(MEDIA_QUERIES.m);

    if (mqM.matches) {
      return this.config.itemsToScroll.m || 1;
    }

    if (mqXl.matches) {
      return this.config.itemsToScroll.xl || 3;
    }

    if (mqXXl.matches) {
      return this.config.itemsToScroll.xxl || 5;
    }

    return this.config.itemsToScroll.m;

    // // mobile
    // let itemsToScroll = 1;

    // if (this.hasFiveSlides) {
    //   itemsToScroll = 2;
    // }

    // // tablet
    // if (mqM.matches) {
    //   itemsToScroll = 2;

    //   if (this.hasFiveSlides) {
    //     itemsToScroll = 3;
    //   }
    // }

    // // tablet landscape or small desktop
    // if (mqXl.matches) {
    //   itemsToScroll = 3;

    //   if (this.hasFiveSlides) {
    //     itemsToScroll = 5;
    //   }
    // }
    // console.log(this);
    // return itemsToScroll;
  }
}
